/* L'AVVIO DEL SITO: quello che si puo' fare in parallelo si fa in parallelo.
 *
 * Prima andava in fila: si aspettava la skin, poi si disegnava, poi si
 * controllava l'accesso, poi si disegnava la Home, e solo allora la Home
 * chiedeva i giochi. Ogni passo aspettava il precedente. Adesso accesso e
 * giochi partono subito, insieme alla skin, e quando React disegna la Home
 * di solito sono gia' arrivati.
 */
import UserService from './components/Home/services/UserService';

let accesso = null;
let pronto = false;

/** Controlla l'accesso (una volta sola): la promessa si risolve a controllo finito. */
export function avviaAccesso() {
  if (!accesso) {
    accesso = new Promise((risolvi) => {
      UserService.initAuth((dentro) => {
        pronto = true;
        risolvi(dentro);
      });
    });
  }
  return accesso;
}

/** L'accesso e' gia' stato controllato? Sincrono: per non mostrare l'attesa quando non serve. */
export function accessoPronto() {
  return pronto;
}
